import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListEvents = (params) => {
    return axios.get(`${backendHost}/api/admin/admin/events/list`, {params});
};

export {
    getListEvents
}